import GroupType from 'models/GroupType';

import { useInboundReferralsInsightsStore } from './inboundReferralsInsightsStore';
import { useInsightsStore } from './insightsStore';
import { useAllPatientsStore, useCoordinatePatientsStore } from './patientFiltersStore';
import { usePortfolioStore } from './portfolioStore';

// Filters picked under one acting client mean nothing under the next. Every path that changes the
// acting client calls this: Select View, and the automatic switch a cross-client link makes.
export function resetClientScopedStores() {
  usePortfolioStore.getState().actions.reset();
  useCoordinatePatientsStore.getState().actions.reset();
  useAllPatientsStore.getState().actions.reset();
  useInsightsStore.getState().actions.setSelectedGroupType({} as GroupType);

  const inboundInsights = useInboundReferralsInsightsStore.getState().actions;
  inboundInsights.resetFilters();
  inboundInsights.closeSlideout();
}
